//import React, { ReactElement } from 'react';

import React, { useState, CSSProperties } from 'react';
import RingLoader from 'react-spinners/RingLoader';

const override: CSSProperties = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'block',
  borderColor: '#E48F45',
};

/**
 * A React component that renders a loading progress bar.
 * If progress is not provided, it will render an infinite loading bar
 * If progress is provided, it will render a progress bar
 * The progress text can be optionally displayed to the left of the bar.
 */
function ProgressLoading({ progress }: { progress?: number }) {
  const [loading, setLoading] = useState(true);
  return (
    <div className="loading">
      {progress === undefined || progress === null ? (
        <RingLoader
          color="#E48F45"
          loading={loading}
          cssOverride={override}
          size={100}
        />
      ) : (
        <div className=""></div>
      )}
    </div>
  );
}

export default ProgressLoading;
